'use client';

import { createContext } from 'react';

/**
 * return Context/Provider with initialState as the default value
 */
export const createContextStore = <T>(initialState: T) => {
  const Context = createContext<T>( initialState );

  return { Context, Provider: Context.Provider };
};
